import { motion, useScroll, useTransform } from "framer-motion";
import { useState } from "react";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import PaymentsIcon from '@mui/icons-material/Payments';


import StackCard from '../component/StackCard'
import Header from '../component/Header'
import Footer from '../component/Footer'
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import Achivment from "../component/Achivment";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { details } from "framer-motion/client";
const tabsData = [
    {
        id: 1,
        title: "International Funding",
        content:
            "Global capital access solutions helping businesses raise cross-border funding and international investments.",
        detailsData:
            [
                {
                    icon: < PaymentsIcon style={{ fontSize: '40px' }} />,
                    title: 'ECB',
                    desc: "External Commercial Borrowings from overseas lenders and institutions. ",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "FDI",
                    desc: "Foreign Direct Investment into Indian businesses and strategic ventures. ",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "Trade & Export Finance",
                    desc: "Cross-border trade finance solutions supporting import-export businesses. ",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "Global Institutional Capital",
                    desc: "Access to international private credit funds, sovereign funds, and offshore investors.",
                }
            ]
    },
    {
        id: 2,
        title: "Government Schemes",
        content:
            "Government-supported funding and guarantee programs designed to promote MSMEs, startups, infrastructure, and manufacturing growth.",
        detailsData:
            [
                {
                    icon: < PaymentsIcon style={{ fontSize: '40px' }} />,
                    title: 'CGTMSE',
                    desc: "Collateral-free credit guarantee scheme for MSMEs. ",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "Mudra",
                    desc: "Micro-business financing initiative supporting small entrepreneurs and startups.",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "SIDBI",
                    desc: "Development finance support for MSMEs and industrial growth initiatives. ",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "PLI",
                    desc: "Production Linked Incentive schemes promoting manufacturing and strategic sectors.",
                }
            ]
    },
    {
        id: 3,
        title: "New Age Funding",
        content:
            "Modern and alternative financing solutions powered by innovation, technology, and evolving investment ecosystems.",
        detailsData:
            [
                {
                    icon: < PaymentsIcon style={{ fontSize: '40px' }} />,
                    title: 'Venture Debt',
                    desc: "Debt funding solutions tailored for startups and venture-backed businesses. ",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "Private Credit",
                    desc: "Alternative non-bank institutional lending solutions for mid-market and growth companies.",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "SPAC",
                    desc: "Capital raising and listing opportunities through Special Purpose Acquisition Companies.",
                },
                {
                    icon: <RocketLaunchIcon style={{ fontSize: '40px' }} />,
                    title: "Tokenization",
                    desc: "Digital asset-backed fundraising and blockchain-enabled investment structuring solutions.",
                }
            ]
    },

];

export default function StructuredFinance() {

    const [activeTab, setActiveTab] = useState(0);



    return (
        <div>
            <Header />
            <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-blue-950 to-cyan-900  pt-36 pb-10 px-4 sm:px-6 lg:px-8">

                <div className="absolute top-0 left-0 w-72 h-72 bg-cyan-500/20 blur-[120px]" />
                <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 blur-[140px] rounded-full" />
                <div className="absolute inset-0 opacity-10 bg-[linear-gradient(rgba(255,255,255,.15)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.15)_1px,transparent_1px)] bg-[size:40px_40px]" />

                <div className="max-w-7xl mx-auto relative z-10">
                    {/* Breadcrumb */}
                    <div className="flex items-center  flex-wrap gap-2 text-sm text-white/70 mb-6">Home
                        <KeyboardArrowRightIcon className="w-4 h-4" />
                        <span className="text-cyan-300">
                            Expertise
                        </span>
                    </div>
                    <div className='max-w-6xl '>
                        <h1 className="text-3xl sm:text-3xl lg:text-4xl font-bold text-white leading-tight mb-5">
                            Expertise{" "}

                        </h1>

                        {/* Description */}
                        <p className=" text-white/70 text-lg sm:text-base lg:text-2xl leading-relaxed mb-20 ">
                            Tailored financial structuring for complex transactions including securitization, LRD, promoter funding, and special situation financing.
                            Focused on creating innovative capital solutions aligned with business cash flows and project viability.

                        </p>
                    </div>
                    {/* tabs section start */}
                    <div className="max-w-7xl mx-auto pb-10">


                        {/* Tabs */}
                        <div className="flex flex-wrap gap-3 mb-8">
                            {tabsData.map((tab, index) => (
                                <button
                                    key={index}
                                    onClick={() => setActiveTab(index)}
                                    className={`px-6 py-3 rounded-lg font-medium transition-all duration-300
              ${activeTab === index
                                            ? "bg-dark-gold text-white shadow-lg scale-105"
                                            : "bg-white/10 text-white hover:bg-white/20"
                                        }`}
                                >
                                    {tab.title}
                                </button>
                            ))}
                        </div>

                        {/* Content */}
                        <div className=" transition-all duration-500">
                            <h3 className="text-3xl font-bold text-white mb-3 mt-16">
                                {tabsData[activeTab].title}
                            </h3>

                            <p className="text-slate-300 text-lg leading-8">
                                {tabsData[activeTab].content}

                            </p>

                            {/* Details Cards */}
                            {tabsData[activeTab].detailsData && (
                                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                                    {tabsData[activeTab].detailsData.map(
                                        (item, index) => (
                                            <div
                                                key={index}
                                                className=" border border-white/10 rounded-sm p-6 hover:bg-white/15 transition-all duration-300 mt-10"
                                            >
                                                {/* <div className="text-4xl mb-4 text-dark-gold">
                                                    {item.icon}
                                                </div> */}

                                                <h4 className="text-xl font-semibold text-white mb-3">
                                                    {item.title}
                                                </h4>

                                                <p className="text-slate-400 text-sm leading-7">
                                                    {item.desc}
                                                </p>
                                            </div>
                                        )
                                    )}
                                </div>
                            )}


                        </div>
                    </div>
                    {/* end */}
                </div>
            </section >


            <Achivment />
            <Footer />
        </div >
    )
}



